import React from 'react';
import PropTypes from 'prop-types';

const InlineValue = props => {
  const { children, toggleEditor, isUrl, userMode, hasManyValues } = props;

  if (userMode === 'reader') {
    return <div>{children}</div>;
  }

  const editHoverStyle = hasManyValues ? { verticalAlign: 'top', height: 'auto' } : {};
  const editHoverWrapper = hasManyValues ? { float: 'right', position: 'absolute', top: 0 } : {};
  // console.log('children', children);
  if (isUrl) {
    return (
      <div className="inlineEditable" style={{ cursor: 'pointer' }}>
        {children}
        <div className="edit-hover">
          <i className="fa fa-pencil" onClick={toggleEditor} />
        </div>
      </div>
    );
  }

  return (
    <div
      className="inlineEditable"
      style={{ cursor: 'pointer', display: 'inline-block' }}
      onClick={toggleEditor}
    >
      {children}
      <div className="edit-hover" style={editHoverWrapper}>
        <i className="fa fa-pencil" style={editHoverStyle} />
      </div>
    </div>
  );
};

InlineValue.propTypes = {
  children: PropTypes.any,
  toggleEditor: PropTypes.func,
  isUrl: PropTypes.bool,
  userMode: PropTypes.string,
  hasListValues: PropTypes.bool,
};

export default InlineValue;



// WEBPACK FOOTER //
// ./src/components/types/InlineValue.js